import { useContext, useEffect } from "react"
import { Grid } from "@material-ui/core";
import { useFormikContext } from 'formik';
import { ticketContext } from '../../../TicketContext';
import { EditRequest } from "./EditRequest"
import { applicationContext } from "helpers/services";
import DeliveryInfo from "./DeliveryInfo";
import ProductInfo from "./ProductInfo";
import { TypeInfo } from "helpers/enums";


let EditeRequestForm = () => {
    let form = useFormikContext<EditRequest>();

    let { ticketTypes } = useContext(applicationContext);

    let { ticket } = useContext(ticketContext)

    useEffect(() => {
        if (ticket.ticketTypeId !== '') {
            let ticketType = ticketTypes.find(x => x.id === ticket.ticketTypeId);
            if (ticketType) {
                form.setFieldValue('typeInfo', ticketType.typeInfo);
            }
        }
    }, [ticket.ticketTypeId])


    return (
        <Grid container>
            {form.values.typeInfo === TypeInfo.Delivery && <DeliveryInfo />}
            {form.values.typeInfo === TypeInfo.Product && <ProductInfo />}
        </Grid>
    )
}

export default EditeRequestForm